import React from 'react';

const PlayAlt = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="23" height="36" viewBox="0 0 23 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M21.6423 15.8045C22.9164 16.9909 22.9164 19.0091 21.6423 20.1955L5.79447 34.9532C3.87596 36.7397 0.75 35.3792 0.75 32.7577L0.750001 3.24231C0.750002 0.620791 3.87596 -0.739712 5.79446 1.04682L21.6423 15.8045Z" fill="#713B3B"/>
    </svg>
  )
};

export default PlayAlt;
